import SectionTitle from "../../../../common/sectionTitle";
import AboutInfoCardList from "../aboutInfoCardList";
import data from "../../../../assets/data/about/aboutv1";
import aboutThumb3 from "../../../../assets/images/about/about-us-01.png";
import coin from "../../../../assets/images/about/about-us-02.png";
import AboutStyleWrapper from "./About.style";
import Button from "../../../../common/button";

const About = () => {
  const { aboutDescription1, aboutDescription2 } = data;
  return (
    <AboutStyleWrapper id="about" >
      <div className="container">
        <div className="row flex-row-reverse">
          <div className="col-lg-6">
            <div className="v1_about_us_right_sect">
              <SectionTitle title="Leading Chain , Crypto & Ico Devlopment Services" subtitle="ABOUT US" />
              <div className="v1_about_us_right_text">
                <p>{aboutDescription1}</p>
                <p>{aboutDescription2}</p>
              </div>
              <Button sm variant="outline" className="learmore_btn">
                Read More
              </Button>
            </div>
          </div>
          <div className="col-lg-6 image_section">
            <img src={aboutThumb3} alt="img" />
            <img src={coin} alt="img" className="coin_img" />
          </div>
        </div>
        <AboutInfoCardList />
      </div>
    </AboutStyleWrapper>
  );
};

export default About;
